var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticStyle:{"font-size":"30px","padding":"10px","margin":"30px auto","display":"block"},on:{"click":_vm.toKnow}},[_vm._v("跳转知识库")])
}
var staticRenderFns = []

export { render, staticRenderFns }